import * as types from '../actionTypes';

export function setResetPending(isLoading) {
  return {
    type: types.SET_RESET_PENDING,
    isLoading,
  };
}

export function setResetSuccess(isLoading, data) {
  return {
    type: types.SET_RESET_SUCCESS,
    isLoading,
    data,
  };
}

export function setResetConfirmSuccess(isLoading, data) {
  return {
    type: types.SET_RESET_CONFIRM_SUCCESS,
    isLoading,
    data,
  };
}

export function setResetPasswordError(isLoading, error) {
  return {
    type: types.SET_RESET_ERROR,
    isLoading,
    error,
  };
}

export function setResetCancel() {
  return {
    type: types.SET_RESET_CANCEL,
  };
}

export function setNewPasswordSuccess(isLoading, data) {
  return {
    type: types.SET_NEW_PASSWORD_SUCCESS,
    isLoading,
    data,
  };
}

export function setNewPasswordError(isLoading, error) {
  return {
    type: types.SET_NEW_PASSWORD_ERROR,
    isLoading,
    error,
  };
}

export function setNewCompanyDetailsSuccess(isLoading, data) {
  return {
    type: types.SET_NEW_COMPANY_SUCCESS,
    isLoading,
    data,
  };
}

export function setNewCompanyDetailsError(isLoading, error) {
  return {
    type: types.SET_NEW_COMPANY_ERROR,
    isLoading,
    error,
  };
}

export function setVerifyUserSuccess(isLoading, data) {
  return {
    type: types.SET_VERIFY_USER_SUCCESS,
    isLoading,
    data,
  };
}

export function removeError() {
  return {
    type: types.SET_CLEAR_ERROR,
  };
}

export function setAgentRemoveInfoError() {
  return {
    type: types.SET_REMOVE_ERROR,
  };
}
